import { Document, Font } from '@react-pdf/renderer';

import RobotoLightFont from '@/assets/fonts/Roboto-Light.ttf';
import RobotoRegularFont from '@/assets/fonts/Roboto-Regular.ttf';

import { PDFBatchFormatType } from './format-batches';
import { SingleMeasurement } from './single-measurment';

export const getPdfDocument = async (data: PDFBatchFormatType[]) => {
  Font.register({
    family: 'Roboto',
    fonts: [{ src: RobotoLightFont, fontWeight: 200 }, { src: RobotoRegularFont }],
  });

  const document = (
    <Document>
      {data.map(({ images, histogram, table }) => (
        <SingleMeasurement
          key={images[0].batchId}
          table={table}
          images={images}
          histogram={histogram}
        />
      ))}
    </Document>
  );

  return document;
};
